import React from 'react'
import styled from 'styled-components'
import { SvgAttr } from '../SvgAttr/SvgAttr'

export const IconArrowDown = ({
  width = '14px',
  color = '#212121',
  point,
  classes,
  styles,
}) => (
  <Svg
    className={`${classes}`}
    width={`${width}`}
    point={point}
    x='0px'
    y='0px'
    viewBox='0 0 14 8'
    styles={styles}
  >
    <title>Arrow Down</title>
    <path
      fill={color}
      d='M6.99848 7.01582C6.6152 7.01651 6.23555 6.94164 5.88122 6.79551C5.52689 6.64937 5.20484 6.43484 4.93348 6.16416L0.167647 1.39832C0.0578034 1.28848 -0.00390625 1.1395 -0.00390625 0.984158C-0.00390625 0.828815 0.0578034 0.679835 0.167647 0.569991C0.277491 0.460147 0.426471 0.398438 0.581814 0.398438C0.737156 0.398438 0.886137 0.460147 0.995981 0.569991L5.76181 5.33582C6.08994 5.66354 6.53473 5.84762 6.99848 5.84762C7.46223 5.84762 7.90702 5.66354 8.23515 5.33582L13.001 0.569991C13.1108 0.460147 13.2598 0.398438 13.4151 0.398438C13.5705 0.398438 13.7195 0.460147 13.8293 0.569991C13.9392 0.679835 14.0009 0.828815 14.0009 0.984158C14.0009 1.1395 13.9392 1.28848 13.8293 1.39832L9.06348 6.16416C8.79212 6.43484 8.47007 6.64937 8.11574 6.79551C7.76141 6.94164 7.38176 7.01651 6.99848 7.01582Z'
    />
  </Svg>
)

const Svg = styled(SvgAttr)`
    ${props => props.styles};
    ${props => props.point === 'down' && `
        transform: rotate(180deg);
    `}
`
